// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"4f455113","625":"b23026d6"}[chunkId] + ".chunk.js";
};